export default {"src":"/_next/static/media/Kuan.b3b353aa.svg","height":350,"width":350,"blurWidth":0,"blurHeight":0};